import axios from 'axios'

const http = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE}`,
  timeout: 50000,
  headers: {
    //'X-Custom-Header': 'foobar',
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    // 'X-CSRF-Token': token,
    'OrderToken': sessionStorage.order_token
  }
});

export default http;

